import { useEffect } from "react";

/**
 * This hook will check if the click is inside the element with the given selector.
 * If it is, it will call the callback function.
 * @param callback - The callback function to call when the click is inside the element.
 * @param selectors - The selectors to check if the click is inside.
 * @returns void
 */
const useClickInsideChecker = (callback: () => void, selectors: string[]) => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const isInside = selectors.some((selector) => target.closest(selector));

      if (isInside) {
        callback();
      }
    };

    const observer = new MutationObserver(() => {
      const found = selectors.some((selector) =>
        document.querySelector(selector),
      );

      if (found) {
        document.addEventListener("mousedown", handleClick);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      document.removeEventListener("mousedown", handleClick);
      observer.disconnect();
    };
  }, [callback, selectors]);
};

export default useClickInsideChecker;
